export const DialogImportationProcessLabels = {
  dialogProcessStatus: 'Estatus de Importación de archivos'
};
